let base_path = `/api/v2/branded-caller-id-orders`

export default {
    fetchBrandedCallerIdOrders(){
        return axios.get(`${base_path}`)
    },

    createBrandedCallerIdOrder(data) {
        return axios.post(`${base_path}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
}
